import { ItemCardInfo } from '@/components/GridItemCard/types/types';

export const DEFAULT_CARD_DIMENSIONS: ItemCardInfo['dimensions'] = {
    desktop: 282,
    mobile: 172,
};
